/**
 * Texto legível de negociações — mesmo estilo dos atendimentos,
 * com volume por origem (como antes) + ganhos/perdidos/vendas por canal.
 */

import type { LeadsAnalysisSummary } from '../../../features/dashboard/lib/buildLeadsSummary';

const money = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
});

const STATUS_LABEL: Record<string, string> = {
    open: 'Em aberto',
    won: 'Ganhos',
    lost: 'Perdidos',
};

function formatVolumePorOrigem(porCanal: LeadsAnalysisSummary['porCanal']): string {
    const entries = Object.entries(porCanal).sort((a, b) => b[1].total - a[1].total);
    if (!entries.length) return '- (sem dados de origem nas negociações)';
    return entries.map(([canal, s]) => `- ${canal}: ${s.total}`).join('\n');
}

function formatResultadoPorCanal(porCanal: LeadsAnalysisSummary['porCanal']): string {
    const entries = Object.entries(porCanal).sort((a, b) => b[1].valorVendas - a[1].valorVendas);
    if (!entries.length) return '- (sem dados)';
    return entries
        .map(([canal, s]) => {
            return (
                `- ${canal}: ${s.ganhos} ganhos | ${s.perdidos} perdidos | ${s.emAberto} em aberto | vendas ${money.format(s.valorVendas)}`
            );
        })
        .join('\n');
}

function formatCountMap(map: Record<string, number>, labelMap?: Record<string, string>): string {
    const entries = Object.entries(map).sort((a, b) => b[1] - a[1]);
    if (!entries.length) return '- (sem dados)';
    return entries
        .map(([k, v]) => `- ${labelMap?.[k] ?? k}: ${v}`)
        .join('\n');
}

/** Bloco em português — alinhado ao estilo de formatChatStatsForPrompt. */
export function formatLeadsSummaryForPrompt(summary: LeadsAnalysisSummary): string {
    return `
TOTAL DE NEGOCIAÇÕES: ${summary.total}
- Valor em carteira (todas): ${money.format(summary.valorTotalNegociacoes)}
- Valor total de vendas (só ganhos): ${money.format(summary.valorTotalVendas)}

ORIGEM DAS NEGOCIAÇÕES (volume por canal — não confundir com origem das conversas):
${formatVolumePorOrigem(summary.porCanal)}

RESULTADO POR CANAL (ganhos, perdidos e vendas):
${formatResultadoPorCanal(summary.porCanal)}

POR STATUS:
${formatCountMap(summary.porStatus, STATUS_LABEL)}

POR VENDEDOR:
${formatCountMap(summary.porVendedor)}

MOTIVOS DE PERDA:
${formatCountMap(summary.porMotivoPerda)}
`.trim();
}
